import moment, {Moment} from 'moment';
import {ChangeEvent, Dispatch, SetStateAction} from 'react';

export function onChange<T>(setter: Dispatch<SetStateAction<T>>) {
  return (e: ChangeEvent<HTMLInputElement> | string | Moment) => {
    if (typeof e === 'string') {
      setter(e as T);
    } else if (moment.isMoment(e)) {
      setter(e.format('YYYY-MM-DD') as T);
    } else setter(e.target.value as T);
  };
}
